import { ModelBase } from '../../shared/base/model-base';

export class Lesson extends ModelBase {
  $exists: any;
  name: string;
  content?: string;
  owner?: string;
  lecture: string;
}



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/lessons/shared/lesson.ts